import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import Tr from '../../../../../../components/common-table/components/Tr';
import TdCheckbox from '../../../../../../components/common-table/components/TdCheckbox';
import Td from '../../../../../../components/common-table/components/Td';
import CommonIconButton from '../../../../../../components/common-icon-button/CommonIconButton';
import { ICONS } from '../../../../../../icons';
import MediaCell from './MediaCell';
import { SOCIAL_MEDIA_TYPE } from '../../../../../../sonar/brand/brand-socials/constants';
import { selectSingleDomain } from '../../../../../../redux/sonar-management/sonarManagementReducer';

import scss from './CollectDataTable.module.scss';

const CollectDataTableItem = ({ data, onEdit, onDelete, disableActionButtons }) => {
  const { count, brandCompany, socials, isSelected, id } = data;
  const dispatch = useDispatch();
  const { t } = useTranslation('projects');

  const handleSelectSingleDomain = () => {
    dispatch(selectSingleDomain(id));
  };

  const handleEdit = () => {
    onEdit(data);
  };

  const handleDelete = () => {
    onDelete(data);
  };

  return (
    <Tr>
      <TdCheckbox selected={isSelected} onSelect={handleSelectSingleDomain} />
      <Td extraClasses='cell-rank'>{count}</Td>
      <Td isLeft extraClasses={scss.companyNameCell}>
        {brandCompany}
      </Td>
      <MediaCell links={socials[SOCIAL_MEDIA_TYPE.FACEBOOK]} />
      <MediaCell links={socials[SOCIAL_MEDIA_TYPE.INSTAGRAM]} />
      <MediaCell links={socials[SOCIAL_MEDIA_TYPE.YOUTUBE]} />
      {/* <MediaCell links={socials[SOCIAL_MEDIA_TYPE.TRUSTPILOT]} /> */}
      <MediaCell links={socials[SOCIAL_MEDIA_TYPE.TWITTER]} />
      <MediaCell links={socials[SOCIAL_MEDIA_TYPE.TIKTOK]} />
      {/* <MediaCell links={socials[SOCIAL_MEDIA_TYPE.LINKEDIN]} /> */}
      <Td extraClasses={scss.cellActions}>
        <CommonIconButton icon={ICONS.Edit} onClick={handleEdit} tooltip={t('edit')} disabled={disableActionButtons} />
        <CommonIconButton
          icon={ICONS.Delete}
          onClick={handleDelete}
          tooltip={t('delete')}
          disabled={disableActionButtons}
        />
        {/* <CommonIconButton icon={ICONS.Return} onClick={() => null} /> */}
      </Td>
    </Tr>
  );
};

export default CollectDataTableItem;
